import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { StoreInfoProvider } from "@/context/StoreInfoContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AnnouncementBar from "@/components/AnnouncementBar";
import ExitIntentGuide from "@/components/ExitIntentGuide";
import SmoothScroll from "@/components/SmoothScroll";
import SplashScreen from "@/components/SplashScreen";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import AdminBlog from "@/pages/AdminBlog";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import FreeGuide from "@/pages/FreeGuide";
import FreeGuideConfirm from "@/pages/FreeGuideConfirm";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { PrivacyPolicy, Terms, RefundPolicy, ShippingPolicy } from "@/pages/LegalPages";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <SplashScreen />
      <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <StoreInfoProvider>
          <BrowserRouter>
            <SmoothScroll>
            <div className="grain-fixed" aria-hidden="true" />
            <AnnouncementBar />
            <Navbar />
            <CartDrawer />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/blog" element={<AdminBlog />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/free-guide" element={<FreeGuide />} />
                <Route path="/free-guide/confirm" element={<FreeGuideConfirm />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
              </Routes>
            </main>
            <Footer />
            <ExitIntentGuide />
            </SmoothScroll>
          </BrowserRouter>
          </StoreInfoProvider>
          <Toaster position="bottom-right" theme="dark" richColors />
        </CartProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
